module.exports = __webpack_public_path__ + "71852520d8933354c9151a99c8511ef5.svg";